import { useRef } from 'react';

// Native OS file picker (hidden <input type=file>) — used where legacy opens the
// browser's file dialog directly (e.g. Login Information Upload), with no modal.
export function useFilePicker(accept: string, onPick: (file: File) => void | Promise<unknown>) {
  const ref = useRef<HTMLInputElement>(null);

  const input = (
    <input
      ref={ref}
      type="file"
      accept={accept}
      className="d-none"
      onChange={(e) => {
        const file = e.target.files?.[0];
        e.target.value = '';
        if (file) void onPick(file);
      }}
    />
  );

  return { input, open: () => ref.current?.click() };
}
